import { render, staticRenderFns } from "./RoadsMap.vue?vue&type=template&id=5d6a35b7&scoped=true&"
import script from "./RoadsMap.vue?vue&type=script&lang=js&"
export * from "./RoadsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6a35b7",
  null
  
)

export default component.exports